import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { CustomerContactInitStepDeclaration } from "./Steps/CustomerContactInitStep";

export const customerContactStartupFlow = new FlowDefinition("CustomerContactFlow");

customerContactStartupFlow.addStep(CustomerContactInitStepDeclaration);
customerContactStartupFlow.setStartStep("CustomerContactInit_Step");

export const customerContactStartupFlowDefinition = new StepDefinition({
  stepName: "CustomerContactFlow",
  stepFlow: customerContactStartupFlow,
  contextIsolation: false,
});
